module.exports = __webpack_public_path__ + "img/bgIcon_9.225df986.png";